export default __webpack_public_path__ + "static/drag-drop-editor-acd7407fe7ce101be5b1c59cc71d8b8b.png";